<!-- Show Scan -->
<app-givi-scanner></app-givi-scanner>

<div>
    <div class="p-20">
        <!-- Mis comunidades -->
        <div class="font-b1">Mis Comunidades</div>

        <ng-container *ngFor="let community of myCommunities; let i = index">

            <div *ngIf="myCommunities?.length && validWeedCR(community)" class="community-card" (click)="onDetailsOrJoin(community)">
                <div class="d-flex align-items-center">
                    <app-img-round [src]="community.imageUrl" [width]="50"></app-img-round>
                    <div class="m-l-10">
                        <div class="d-flex align-items-center m-t-10 font-14 font-bold" style="line-height: 14px;">
                            <span>
                                {{community.name}} 
                                <img *ngIf="community.country == 1" src="https://cdn-icons-png.flaticon.com/128/4854/4854928.png" width="10">
                                <img *ngIf="community.country == 2" src="https://cdn-icons-png.flaticon.com/128/197/197590.png" width="10">
                            </span> 
                        </div>
                        <div class="font-10">{{community.description | truncate:87 :true}}</div>
                    </div>
                </div>
                <div class="d-flex align-items-center m-l-10">
                    <div class="btn-go" [style.background-color]="community.colorTheme">
                        <i class="mdi mdi-arrow-right text-white" style="font-size: 20;"></i>
                    </div>
                </div>
            </div>
        </ng-container>

        <div *ngIf="!myCommunities?.length" class="text-center m-t-20">
            <div class="font-12 text-muted">No perteneces a ninguna comunidad aún</div>
        </div>

        <div class="font-14 text-center text-primary font-bold m-t-20" (click)="goToCommunities()">
            Explorá más comunidades <i class="mdi mdi-arrow-right" style="vertical-align: middle;"></i>
        </div>
        
    </div> 

    <div class="p-20">
        <!-- Mis Planesde lealtad -->
        <div class="font-b1">Mis Planes de Lealtad</div>
        <ng-container *ngFor="let plan of myLoyaltyPlans; let i = index">
            <div class="plan-card" (click)="onGoToMyPlan(plan)">
                <div class="d-flex-between align-items-center w-100">
                    <div class="d-flex align-items-center">
                        <div class="img-background d-flex-center align-items-center">
                            <img [src]="plan?.vendor?.logoURL" width="40">
                        </div>
                        <div class="font-14 font-bold ml-2">{{plan.name}}
                            <img *ngIf="plan.country == 1" src="https://cdn-icons-png.flaticon.com/128/4854/4854928.png" width="10">
                            <img *ngIf="plan.country == 2" src="https://cdn-icons-png.flaticon.com/128/197/197590.png" width="10">
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="btn-go" [style.background-color]="plan.colorTheme">
                            <i class="mdi mdi-arrow-right text-white" style="font-size: 20;" [style.color]="plan.colorIcon"></i>
                        </div>
                    </div>  
                </div>
                <div class="m-t-10">
                    <div class="d-flex" style="flex-wrap: wrap !important;">
                        <ng-container *ngFor="let item of plan.ordinalList; let i = index">
                            <!-- Stickers asignados -->
                            <div *ngIf="item.ordinal <= plan.customer.stickers.length">
                                <!-- Ya vio el premio -->
                                <ng-container *ngIf="item.isClaimed">
                                    <!-- Si no tiene tienda o el comercio es igual -->
                                    <div *ngIf="!plan.customer.stickers[i].store || plan.customer.stickers[i].store.vendorId == plan.vendorId" 
                                        class="sm-full-circle" [style.backgroundColor]="plan.colorTheme"
                                        [style.color]="plan.colorIcon">
                                        <i class="font-16" [class]="plan.iconUrl"></i>
                                    </div>
                                    <!-- Tiene tienda con diferente comercio -->
                                    <div *ngIf="plan.customer.stickers[i].store && plan.customer.stickers[i].store.vendorId != plan.vendorId">
                                        <img class="sm-full-circle" src="{{plan.customer.stickers[i].store.vendor?.logoURL}}" width="15">
                                    </div>
                                </ng-container> 
                                <!-- No ha visto el premio -->
                                <ng-container *ngIf="!item.isClaimed">
                                    <div style="width: 25px; height: 25px; margin: 5px 5px 0px 0px;">
                                        <img src="assets/images/icono_plan.png" class="w-100">
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Stickers pendientes -->
                            <div *ngIf="item.ordinal > plan.customer.stickers.length">
                                <div *ngIf="item.couponId == 0 && item.scratchId == 0 || !item.isActive" class="sm-dashed-circle"></div>
                                <div *ngIf="item.couponId > 0 && item.isActive" class="sm-dashed-circle">
                                    <i class="mdi mdi-trophy-outline font-16 text-muted"></i>
                                </div>
                                <div *ngIf="item.scratchId > 0 && item.isActive" class="sm-dashed-circle">
                                    <i class="mdi mdi-help-circle-outline font-16 text-muted"></i>
                                </div>
                            </div> 
                        </ng-container>
                    </div>
                </div>
            </div>
            <!-- small -->
            <div *ngIf="false" class="plan-card" (click)="onGoToMyPlan(plan)">
                <div class="d-flex-between align-items-center w-100">
                    <div class="d-flex align-items-center">
                        <div class="img-background d-flex-center align-items-center" style="width: 30px; height: 30px;">
                            <img [src]="plan?.vendor?.logoURL" width="30">
                        </div>
                        <div class="font-14 font-bold ml-2">{{plan.name}}
                            <img *ngIf="plan.country == 1" src="https://cdn-icons-png.flaticon.com/128/4854/4854928.png" width="10">
                            <img *ngIf="plan.country == 2" src="https://cdn-icons-png.flaticon.com/128/197/197590.png" width="10">
                        </div>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="btn-go" [style.background-color]="plan.colorTheme">
                            <i class="mdi mdi-arrow-right text-white" style="font-size: 20;" [style.color]="plan.colorIcon"></i>
                        </div>
                    </div>  
                </div>
                <div class="d-flex flex-wrap m-t-10">
                    <ng-container *ngFor="let item of plan.ordinalList; let i = index">
                        <!-- Stickers asignados -->
                        <div *ngIf="item.ordinal <= plan.customer.stickers.length" class="sm-full-circle" 
                        [style.backgroundColor]="plan.colorTheme" [style.color]="plan.colorIcon" >
                            <i class="font-16" [class]="plan.iconUrl"></i>
                        </div>
                        <!-- Stickers pendientes -->
                        <div *ngIf="item.ordinal > plan.customer.stickers.length">
                            <div *ngIf="item.couponId == 0 && item.scratchId == 0 || !item.isActive" class="sm-dashed-circle"></div>
                            <div *ngIf="item.couponId > 0 && item.isActive" class="sm-dashed-circle">
                                <i class="mdi mdi-trophy-outline font-16 text-muted"></i>
                            </div>
                            <div *ngIf="item.scratchId > 0 && item.isActive" class="sm-dashed-circle">
                                <i class="mdi mdi-help-circle-outline font-16 text-muted"></i>
                            </div>
                        </div> 
                    </ng-container>
                </div>

            </div>
        </ng-container> 
        <div *ngIf="!loadedPlans" class="text-center m-t-20">
            <div class="font-12 text-muted">Cargando la lista de planes...</div>
        </div>
        <div *ngIf="myLoyaltyPlans.length == 0 && loadedPlans" class="text-center m-t-20">
            <div class="font-12 text-muted">No tienes ningún plan de lealtad.</div>
        </div>

        <div class="font-14 text-center text-muted m-t-20" (click)="goToLoyaltyPlans()">
            Ver más planes <i class="mdi mdi-arrow-right" style="vertical-align: middle;"></i>
        </div>

    </div>

    <div *ngIf="user.country == 1" class="p-20" style="background-color: #fff; box-shadow: 0px -6px 6px -3px rgba(32, 32, 32, 0.2);">
        <!-- Explora Givi -->
        <div class="info-box p-10 m-t-10" style="position: relative;" (click)="navigateToPage('market-cr')">
            <div class="d-flex align-items-center">
                <div style="background-color: #EBF3FF; border-radius: 10px; padding: 10px;">
                    <img src="assets/images/explora.png" width="45">
                </div>
                <div class="ml-3">
                    <div class="font-16 font-bold">
                        Explorá Givi
                    </div>
                    <div class="font-14">
                        Descubrí cientos de beneficios, ofertas, regalos y más...
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
